import React from "react";
import { withTranslation } from "react-i18next";
import {Badge, Button, Card, Col, Container, Row} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBatteryFull, faWifi} from "@fortawesome/fontawesome-free-solid";
import {faLink, faCircleNotch, faBolt, faHandPaper} from "@fortawesome/free-solid-svg-icons";

import "./RunningExamination.css"
import ValidationHelper from "../../../helpers/ValidationHelper";

const RunningExamination = props => {
    let hardwareWifi = "";
    let hardwareBatteries = "";
    let remoteAttestation = "";
    let raisedHand = "";

    if (props.camplaLernstickBridgeService.hasAPI()
    && props.camplaLernstickBridgeService.hasExamination()){
        raisedHand = props.camplaLernstickBridgeService.isHandRaised() ? (
            <Button
                onClick={() => props.camplaLernstickBridgeService.raiseHand(false)}
                className="btn-black btn-sm mr-3">
                <FontAwesomeIcon icon={faHandPaper} className="color-yellow" />
            </Button>
        ) : (
            <Button
                onClick={() => props.camplaLernstickBridgeService.raiseHand(true)}
                className="btn-green btn-sm mr-3">
                <FontAwesomeIcon icon={faHandPaper} />
            </Button>
        )
    }

    if (props.camplaLernstickBridgeService.hasHardware()){
        // Add a remote attestation staging button
        if (ValidationHelper.isRemoteAttestation(props.camplaLernstickBridgeService.getRemoteAttestationObject())){
            remoteAttestation = <><span className="ml-3 mr-3"></span><Button
                className="btn-green btn-sm mr-3"
                onClick={props.onRemoteAttestationStage}><FontAwesomeIcon icon={faLink} /></Button></>;
        }

        // Add WiFi connection quality
        const wifi = props.camplaLernstickBridgeService.getWifiObject();
        if (wifi){
            if (wifi.connected){
                let quality = <Badge className="btn-green">
                    {props.t("ExaminationAccess.RunningExamination.Quality")}: {wifi.quality}%
                </Badge>;
                if (wifi.quality <= 65.0 && wifi.quality > 40.0){
                    quality = <Badge className="btn-yellow">
                        {props.t("ExaminationAccess.RunningExamination.Quality")}: {wifi.quality}%
                    </Badge>;
                }else if(wifi.quality <= 40.0){
                    quality = <Badge cclassName="btn-red">
                        {props.t("ExaminationAccess.RunningExamination.Quality")}: {wifi.quality}%
                    </Badge>;
                }
                hardwareWifi = <>
                    <FontAwesomeIcon icon={faWifi} className="mr-2" />
                    <Badge className="btn-black mr-2">{wifi.ssid}</Badge>{quality}
                </>;
            }else{
                hardwareWifi = <>
                    <FontAwesomeIcon icon={faWifi} className="mr-2" />
                    <Badge className="btn-red">
                        {props.t("ExaminationAccess.RunningExamination.NoConnection")}
                    </Badge>
                </>;
            }
        }

        // Add battery levels
        const batteries = props.camplaLernstickBridgeService.getBatteriesArray();
        const bats = batteries.map((prec, idx) => {
            if (prec > 50){
                return <Badge className="btn-green mr-2">{batteries.length === 1 ? "" : (<>{idx + 1}: </>)}{prec}%</Badge>;
            }else if(prec <= 50 && prec > 25){
                return <Badge className="btn-yellow mr-2">{batteries.length === 1 ? "" : (<>{idx + 1}: </>)}{prec}%</Badge>;
            }else{
                return <Badge className="btn-red mr-2">{batteries.length === 1 ? "" : (<>{idx + 1}: </>)}{prec}%</Badge>;
            }
        });
        const acConnectedIcon = props.camplaLernstickBridgeService.isACConnected() ? (<span className="fa-layers fa-fw mr-2">
          <FontAwesomeIcon icon={faBatteryFull} />
          <FontAwesomeIcon icon={faBolt} size="xs" />
      </span>) : (<FontAwesomeIcon icon={faBatteryFull} className="mr-2" />);

        hardwareBatteries = bats.length > 0 ? (<>
            <span className="ml-3 mr-3">|</span>
            {acConnectedIcon}{bats}
        </>) : "";

    }

    const examination = props.camplaLernstickBridgeService.getRunningExamination();
    const runningExamination = props.camplaLernstickBridgeService.hasExamination() ? (
        <Row>
            <Col>
                <h4>
                    {props.t("ExaminationAccess.RunningExamination.Examination")}: {examination.name}
                </h4>
            </Col>
            <Col>
                <h4 className="floatRight">
                    {props.waitingForExaminationStart ? (
                        <FontAwesomeIcon icon={faCircleNotch} spin />
                    ) : (examination.isRunning ? (
                        <Badge className="btn-green">
                            {props.t("ExaminationAccess.RunningExamination.IsRunning")}
                        </Badge>
                    ) : (
                        <Badge className="btn-black">
                            {props.t("ExaminationAccess.RunningExamination.IsStopped")}
                        </Badge>
                    ))}
                </h4>
            </Col>
        </Row>
    ) : (
        <Row>
            <Col>
                <h4>{props.t("ExaminationAccess.RunningExamination.NoRunningExamination")}</h4>
            </Col>
        </Row>
    )

    return (
        <>
            <Row className="pageTitle">
                <Col>
                    <h2>{props.t("ExaminationAccess.Title")}</h2>
                </Col>
                <Col className="p-0 pt-2">
                    <div className="floatRight">
                        {hardwareWifi}
                        {hardwareBatteries}
                        {remoteAttestation}
                        {raisedHand}
                    </div>
                </Col>
            </Row>
            <Row className="pb-3">
                <Col>
                    <Card className="mb-2">
                        <Card.Body className="p-2" style={{backgroundColor: "#e0e9e7"}}>
                            <Container>
                                {runningExamination}
                            </Container>
                        </Card.Body>
                    </Card>
                    <hr />
                </Col>
            </Row>
        </>
    )
};

export default withTranslation()(RunningExamination);
